var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDollarWithCheckmark = function SvgDollarWithCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#10A2FC",
    clipPath: "url(#clip0_4035_24339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.9 24.1a11.49 11.49 0 1 1 11.47-11.5A11.5 11.5 0 0 1 58.9 24.09v.03Zm0-20.56a9.07 9.07 0 1 0 0 18.14 9.07 9.07 0 0 0 0-18.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.24 16.59-3.85-3.86 1.7-1.69 2.15 2.15 4.27-4.27 1.71 1.71-5.98 5.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.49 75A37.55 37.55 0 0 1 0 37.49 37.53 37.53 0 0 1 52.5 3.13l-.96 2.22A35.09 35.09 0 0 0 2.41 37.5 35.13 35.13 0 0 0 37.5 72.57a35.13 35.13 0 0 0 35.08-35.08c0-7.07-2.1-13.86-6.03-19.67l2-1.35A37.29 37.29 0 0 1 75 37.49a37.53 37.53 0 0 1-37.49 37.49l-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.49 68.1A30.66 30.66 0 0 1 6.87 37.5 30.66 30.66 0 0 1 49.06 9.14l-.92 2.24A28.24 28.24 0 0 0 9.28 37.5a28.24 28.24 0 0 0 28.2 28.2 28.24 28.24 0 0 0 24.28-42.59l2.08-1.23a30.66 30.66 0 0 1-26.35 46.24v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7 17.45h-2.42v4.46h2.41v-4.46Zm0 35.64h-2.42v4.36h2.41v-4.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.49 54.3c-5.4 0-9.77-4.03-9.77-9h2.41c0 3.64 3.3 6.58 7.36 6.58 4.05 0 7.35-2.96 7.35-6.58s-3.3-6.58-7.35-6.58V36.3c5.4 0 9.76 4.02 9.76 8.99 0 4.97-4.39 9-9.76 9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.49 38.7c-5.4 0-9.77-4.03-9.77-9s4.4-9 9.77-9c5.37 0 9.76 4.03 9.76 9h-2.4c0-3.64-3.31-6.58-7.36-6.58-4.05 0-7.36 2.96-7.36 6.58s3.3 6.58 7.36 6.58v2.41Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4035_24339"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 75,
    width: 75,
    fill: "#fff",
    d: "M0 0h75v75H0z"
  })))));
};
export default SvgDollarWithCheckmark;